import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CellAlignmentEnum, ConfigColumn, NumberColumnPipe, TypeColumn } from '@eqproject/eqp-table';
import { TranslateService } from '@ngx-translate/core';
import { CashFlowDetailDTO, DocumentDTO } from '../../../../models/document.model';
import { DueInvoiceService } from '../../../../services/due-invoice.service';
import { ReceiptService } from '../../../../services/receipt.service';
import { CompanyDTO } from '../../../../models/company.model';
import { CompanyService } from '../../../../services/company.service';
import { GlobalService } from '../../../../services/global.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { info, timeStamp } from 'console';
import { NamirialpayService } from '../../../../services/namirialpay.service';
import { CompanyPayContextDTO, ContextPayEnum } from '../../../../models/commercialProduct.model';
import { UtilityService } from '../../../../services/utility.service';
import { NamirialPayStatusEnum,DueInvoiceDTO, NamirialPayLinkDTO } from '../../../../models/dueInvoice.model';
import { DialogService } from '../../../../services/dialog.service';
import { LicenceService } from '../../../../services/licence.service';


@Component({
  selector: 'app-namirialpay-payments',
  templateUrl: './namirialpay-payments.component.html',
  styleUrls: ['./namirialpay-payments.component.scss']  
})
export class NamirialpayPaymentsComponent implements OnInit {
    
  cashFlowDetail: CashFlowDetailDTO = new CashFlowDetailDTO;  
  dueInvoice: DueInvoiceDTO = new DueInvoiceDTO;
  namirialPayLink: NamirialPayLinkDTO = new NamirialPayLinkDTO;
  isProforma: boolean;
  currentCompany: CompanyDTO;
  idDocument: number;
  idDueInvoice: number;

  
  CashFlowColumns: Array<ConfigColumn> = new Array<ConfigColumn>();
  contextPayEnumArray = Array<any>();
  namirialPayForm: UntypedFormGroup;    
  formattedText = "";
  isNamirialPayActive: number = 0;
  namirialPayContext: Array<CompanyPayContextDTO> = new Array<CompanyPayContextDTO>();  

  constructor(    
    public translate: TranslateService,
    private namirialpayService: NamirialpayService,
    private receiptService: ReceiptService,
    private formBuilder: UntypedFormBuilder,
    private companyService: CompanyService,
    private dialogRef: MatDialogRef<NamirialpayPaymentsComponent>,
    private utilityService: UtilityService,
    private licenceService: LicenceService,
    @Inject(MAT_DIALOG_DATA) public data: any    
  ) { 
  

  }

  async ngOnInit() {    
    this.createForm();
    this.dialogRef.disableClose = false;
    this.idDocument = this.data.idDocument;
    this.idDueInvoice = this.data.idDueInvoice;
    this.cashFlowDetail = await this.namirialpayService.GetCashFlowDetailToNamirialPay(this.idDocument,this.idDueInvoice);   
    this.isNamirialPayActive = GlobalService.companyDashboardStaticObject?.isNamirialPayActive;
    
    this.cashFlowDetail.DueInvoices = this.cashFlowDetail.DueInvoices.map(invoice => {
      invoice.NamirialPayLink = Object.assign(new NamirialPayLinkDTO(), invoice.NamirialPayLink);
      return invoice;
    });
    
    

    this.currentCompany = await this.companyService.getCompanyByID(GlobalService.getUsedCompany());
    this.contextPayEnumArray = this.utilityService.GetEnumArray(ContextPayEnum, true, this.translate, "ENUMS.CONTEXT_PAY.");    
    this.isProforma = (this.cashFlowDetail != null && this.cashFlowDetail.DocumentType != null && this.cashFlowDetail.DocumentType?.FullObject.CodeType == 'PRO') ? true : false;

    this.licenceService.GetPayContextByCompany(this.currentCompany.ID).then((res) => {      
      this.namirialPayContext = res;      
    });
  }

  
  createForm() {
      
    this.namirialPayForm = this.formBuilder.group({
      servizio: [this.namirialPayLink.ServicePay == null? 0: this.namirialPayLink.ServicePay  , Validators.required]      
    });
  }
  
  onServiceChange(invoice: any) {    
    this.dueInvoice = invoice;   
    this.namirialPayLink = invoice.NamirialPayLink; 
  }

  idStatusToText(namirialpaylink: any): string {
      
      let result: string = "";
      
      if (namirialpaylink == null) {
        return result;
      }

      // Status
      // Richiesta da inviare
      // Richiesta inviata e in attesa
      // Incassata
      // Non autorizzata o altro errore

      if (namirialpaylink.PayStatoOperazione != null) {

        let payStatusEnumMap = {
          [NamirialPayStatusEnum.NOTHING]: 'NOTHING',
          [NamirialPayStatusEnum.CARICATA]: 'CARICATA',
          [NamirialPayStatusEnum.INSOLUTA]: 'INSOLUTA',
          [NamirialPayStatusEnum.IN_CORSO]: 'IN_CORSO',
          [NamirialPayStatusEnum.ANNULLATA]: 'ANNULLATA',
          [NamirialPayStatusEnum.SCADUTA]: 'SCADUTA',
          [NamirialPayStatusEnum.BAD_INFO]: 'BAD_INFO',
          [NamirialPayStatusEnum.INCASSATA]: 'INCASSATA',
          [NamirialPayStatusEnum.DA_INVIARE]: 'DA_INVIARE',
        };
        //result = namirialpaylink.PayStatoOperazione;        
        result = this.translate.instant("ENUMS.NAMIRIAL_PAY_STATUS." + payStatusEnumMap[namirialpaylink.PayStatoOperazioneEnum]);
      }
            
      if (result == "") 
      {      
        if (namirialpaylink.RequestStatus == null) {
          result = "";
          return result;
        }
        
        if (namirialpaylink.RequestStatus == 0) {
          result = "Sent";        
        }
        else       
        {    
          result = 'Error';        
        }
      }
            
      return result;
    }

  NamirialPayOperation(invoice: DueInvoiceDTO, operation: number) {    
    
    
    if (this.isNamirialPayActive > 1 && (invoice.NamirialPayLink == null || invoice.NamirialPayLink.ServicePay == null)) {
      DialogService.Error(this.translate.instant("DIALOGS.NAMIRIAL_PAY_ERROR"));
      return;
    }

    if (this.isNamirialPayActive == 1) {
      invoice.NamirialPayLink.ServicePay = 0;
    }
    

    if (invoice?.ScheduleData?.ResidualAmount != null && invoice?.ScheduleData?.ResidualAmount == 0) {      
      DialogService.Error(this.translate.instant("DIALOGS.NAMIRIAL_PAY_ALREADY_PAID"));
      return;
    }
    
    let errmsg: string = this.getNamirialPayErrorMessage(operation, invoice);
    
    if (errmsg != "") {
      DialogService.Error(errmsg);
      return;
    }

    let resultCheck = this.checkNamirialPayLink(invoice);    
    if (operation == 1 && resultCheck < 0) {
      return;
    }

    if (operation == 1 && resultCheck == 1) {
      let daysLink = this.namirialPayContext.find(x => x.ServicePay == invoice?.NamirialPayLink?.ServicePay)?.DaysLink ?? null;
      const referenceDate = new Date();
      referenceDate.setHours(0, 0, 0, 0);
      referenceDate.setDate(referenceDate.getDate() + daysLink);      
      let formattedData = referenceDate.toLocaleDateString('it-IT');

        DialogService.Confirm(this.translate.instant("DIALOGS.NAMIRIAL_PAY_NEAR_EXPIRED" , { days: daysLink, dataval: formattedData }), () => {          
          this.NamirialPayOperation(invoice,99);
        }, true);      
        return;                  
    }
    
    if (operation == 99) {
      operation = 1;
    }

    if (operation == 2) {
      // Richiesta di eliminazione pagamento      
      DialogService.Confirm(this.translate.instant("DIALOGS.NAMIRIAL_PAY_DELETE"), () => {
        this.namirialpayService.NamirialPayRemoveRequest(invoice.ID).then((res) => {
          this.getCashFlowDetail();
          GlobalService.LoadInfoNamirialPayLinkPackage(this.currentCompany.ID);    
        }).catch((err) => {
          DialogService.Error(err.message);
        })                  
      }, true);
      return;
    }

    if (operation == 3) {      
      // Richiesta di invio email con link
      if (invoice.NamirialPayLink.RequestStatus != 0 && invoice.NamirialPayLink.idOperazione == null)  {        
        DialogService.Confirm(this.translate.instant("DIALOGS.NAMIRIAL_PAY_GENERATE_REQUEST"), () => {
          this.NamirialPayOperation(invoice,1);
          return;
        }, true);
      }
      else
      {
        
        if (invoice.NamirialPayLink.dataOraValiditaLink != null && new Date(invoice.NamirialPayLink.dataOraValiditaLink) <= new Date()) {
          DialogService.Error(this.translate.instant("GENERIC_LABEL.NAMIRIAL_PAY_LINK_EXPIRED"));          
          return;
        }

        DialogService.Confirm(this.translate.instant("DIALOGS.NAMIRIAL_PAY_SEND_EMAIL"), () => {
          this.namirialpayService.NamirialPaySendEmail(invoice.ID, invoice.NamirialPayLink.ServicePay).then((res) => {
            DialogService.Success(this.translate.instant("DIALOGS.NAMIRIAL_PAY_SUCCESS"));          
          }).catch((err) => {
            DialogService.Error(err.message);
          })                  
        }, true);
        return;
      }

    }


    if (operation == 1) {
            
      this.namirialpayService.NamirialPayOnlineWS(invoice.ID, invoice.NamirialPayLink.ServicePay).then((res) => {
          if (res != null) {
              this.getCashFlowDetail();

              if (res.codiceRisultato == "0") {
                DialogService.Success(this.translate.instant("DIALOGS.NAMIRIAL_PAY_SUCCESS"));
              };
              
              GlobalService.LoadInfoNamirialPayLinkPackage(this.currentCompany.ID);    
          };
           
          }).catch((err) => {
            DialogService.Error(err.message);
          })
    };


    // Richiesta di pagamento
    
    
    
  }

  getNamirialPayErrorMessage(operation: number, invoice: any): string {
    const payStatus = invoice?.NamirialPayLink?.PayStatoOperazione;
    const requestStatus = invoice?.NamirialPayLink?.RequestStatus;
    const operationId = invoice?.NamirialPayLink?.idOperazione;
  
    if (payStatus === "INCASSATA") {
      return this.translate.instant("DIALOGS.NAMIRIAL_PAY_ALREADY_PAID");
    }

    
    if (operation === 1 || operation === 3) {      
      
      if (operation === 1 && operationId) {
        return this.translate.instant("DIALOGS.NAMIRIAL_PAY_ALREADY_SEND");
      }
    }
  
    return "";
  }

  checkNamirialPayLink(invoice: any): number {
    
    const servicepay = invoice?.NamirialPayLink?.ServicePay;
    
    let daysLink = this.namirialPayContext.find(x => x.ServicePay == servicepay)?.DaysLink ?? null;
    
    if (!daysLink ) {
      DialogService.Error(this.translate.instant("EXCEPTIONS.NAMIRIAL_PAY_CONTEXT"));      
      return -1;
    }
            
    //#DAYS#
    if (daysLink > 0) {
      const referenceDate = new Date();
      referenceDate.setHours(0, 0, 0, 0);
      referenceDate.setDate(referenceDate.getDate() + daysLink);      
      let formattedData = referenceDate.toLocaleDateString('it-IT');

      let checkDate = UtilityService.checkNamirialPayLinkValidity(invoice.ExpireDate, daysLink);
      
      if (checkDate == 1) {
        DialogService.Error(this.translate.instant("EXCEPTIONS.NAMIRIAL_PAY_LINK_VALIDTY", { days: daysLink, dataval: formattedData }));        
        return -1;        
      }
      else if (checkDate == 2) {
        // DialogService.Confirm(this.translate.instant("DIALOGS.NAMIRIAL_PAY_NEAR_EXPIRED",  { days: daysLink, dataval: formattedData }), () => {          
        //   return true;
        // }, true);                        
        return 1
      }
    }
    return 0;
  } 
  
  NamirialPayUpdate(invoice: DueInvoiceDTO) {    

    const operationId = invoice?.NamirialPayLink?.idOperazioneFP;

    if (operationId) {
      this.namirialpayService.NamirialPayOnlineByIdOperazione(invoice.ID, invoice.NamirialPayLink.ServicePay).then((res) => {
        if (res != null && res != -1) {                      
              this.getCashFlowDetail();            
        };
        
        }).catch((err) => {
          DialogService.Error(err.message);
        });
    }
    
    return;

  }

  showresponse(invoice: DueInvoiceDTO) {        
    let jsonString = invoice.NamirialPayLink.PayResponse ;
    this.formattedText = "";        
    if (jsonString != null && jsonString != "") {         
      try {
        const parsed = JSON.parse(jsonString);
        this.formattedText = this.formatAsText(parsed);
      } catch (e) {
        this.formattedText = 'Errore: la stringa JSON non è valida.';
      }
      
      DialogService.Info(this.formattedText, null, true);   
      return;   
    }

    if (invoice.NamirialPayLink.RequestStatus != 0 ) {
      if (invoice.NamirialPayLink.RequestReponse != null) {
        DialogService.Error(this.parseXmlErrorsToText(invoice.NamirialPayLink.RequestReponse));      
      }
      
    }
    else {      
      DialogService.Info(this.translate.instant("GENERIC_LABEL.NAMIRIAL_PAY_DUEINVOICE_PENDING") + " id:" + invoice.NamirialPayLink?.idOperazione );
    }
    
        
    
  }

  formatAsText(obj: any, indent: number = 0): string {
    const padding = '  '.repeat(indent);
    let output = '';
  
    for (const key in obj) {
      const value = obj[key];
  
      if (typeof value === 'object' && value !== null) {
        output += `${padding}${key}:\n${this.formatAsText(value, indent + 1)}`;
      } else {
        output += `${padding}${key}: ${value !== null ? value : '—'}\n`;
      }
    }
  
    return output;
  }

  parseXmlErrorsToText(xmlString: string): string {
    const wrappedXml = `<Root>${xmlString}</Root>`;
  const parser = new DOMParser();
  const xml = parser.parseFromString(wrappedXml, 'application/xml');
  const errors: string[] = [];

  const errorNodes = xml.getElementsByTagName("Errori")[0]?.children || [];
  const codeNodes = xml.getElementsByTagName("ErrorCodes")[0]?.children || [];

  for (let i = 0; i < errorNodes.length; i++) {
    const key = errorNodes[i].nodeName;
    const message = errorNodes[i].textContent?.trim() || "—";

    const codeNode = Array.from(codeNodes).find(n => n.nodeName === key);
    const code = codeNode?.textContent?.trim();

    const line = `${key}: ${message}${code ? ` (${code})` : ""}`;
    errors.push(line);
    }
  
    return errors.join("\n");
  }

  async getCashFlowDetail() {      
      this.cashFlowDetail = await this.namirialpayService.GetCashFlowDetailToNamirialPay(this.idDocument,this.idDueInvoice);    
    }
  
    closeform() {      
      let isValid = false;
    
      for (const invoice of this.cashFlowDetail.DueInvoices) {
        if (invoice.NamirialPayLink != null && invoice.NamirialPayLink.idOperazioneFP != null) {
          isValid = true;
          break;
        }
      }
    
      this.dialogRef.close(isValid); // Chiusura del dialogo con il valore booleano
    }
    
  
}
